import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTransportationTypeList(params) {
  return request({
    url: URL.mdm.basicData.transportationType,
    method: 'get',
    params
  })
}

export function saveTransportationType(data) {
  return request({
    url: URL.mdm.basicData.transportationType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function deleteTransportationType(data) {
  return request({
    url: URL.mdm.basicData.transportationType,
    method: 'delete',
    data
  })
}
